export default __webpack_public_path__ + "static/media/1979.31df9dee.png";